import "core-js/modules/es.function.name.js";
import React from 'react';
import { useLocation } from 'react-router-dom';
import AssetEditor from 'screens/AssetEditor';
import AssetAnalyticsPage from 'screens/AssetAnalyticsPage';
import AssetSharePage from 'screens/AssetSharePage';
import { useGetSharingPermissions } from 'screens/ShareModal';
import { useGetTabInfo } from 'screens/AssetManager';
import SingleAssetHeader from './SingleAssetHeader';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function SingleAssetManager(_ref) {
  var inContentManagerContext = _ref.inContentManagerContext,
    hasOpenOption = _ref.hasOpenOption,
    titleId = _ref.titleId,
    asset = _ref.asset,
    parentPlaylist = _ref.parentPlaylist,
    getIsActiveTab = _ref.getIsActiveTab,
    getTabLink = _ref.getTabLink,
    onClose = _ref.onClose,
    onSubmit = _ref.onSubmit,
    setHasChanges = _ref.setHasChanges;
  var location = useLocation();
  var _useGetSharingPermiss = useGetSharingPermissions({
      name: asset.name,
      contentIds: [asset.id],
      contentParentPlaylistId: parentPlaylist === null || parentPlaylist === void 0 ? void 0 : parentPlaylist.id
    }),
    shareData = _useGetSharingPermiss.shareData;
  var _useGetTabInfo = useGetTabInfo({
      getTabLink: getTabLink,
      getIsActiveTab: getIsActiveTab,
      location: location,
      tabs: ['details', 'analytics', 'share']
    }),
    tabLinks = _useGetTabInfo.tabLinks,
    activeTab = _useGetTabInfo.activeTab;
  var renderActiveTab = function renderActiveTab() {
    switch (activeTab) {
      case 'details':
        return /*#__PURE__*/_jsx(AssetEditor, {
          asset: asset,
          parentPlaylist: parentPlaylist,
          onSubmit: onSubmit,
          onClose: onClose,
          inContentManagerContext: inContentManagerContext,
          setHasChanges: setHasChanges
        });
      case 'analytics':
        return /*#__PURE__*/_jsx(AssetAnalyticsPage, {
          id: asset.id,
          playlistId: parentPlaylist === null || parentPlaylist === void 0 ? void 0 : parentPlaylist.id,
          name: asset.name,
          type: asset.type
        });
      case 'share':
        return /*#__PURE__*/_jsx(AssetSharePage, {
          id: asset.id,
          shareData: shareData,
          playlistId: parentPlaylist === null || parentPlaylist === void 0 ? void 0 : parentPlaylist.id
        });
      default:
        return null;
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SingleAssetHeader, {
      hasOpenOption: hasOpenOption,
      parentPlaylistId: parentPlaylist === null || parentPlaylist === void 0 ? void 0 : parentPlaylist.id,
      titleId: titleId,
      asset: asset,
      onClose: onClose,
      shareData: shareData,
      tabLinks: tabLinks
    }), renderActiveTab()]
  });
}
export default SingleAssetManager;